
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/aboveground",
      function () {
        return require("private-next-pages/archive/aboveground.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/aboveground"])
      });
    }
  